import React, { useEffect } from 'react';

const Script: React.FC<{ code: string }> = ({ code }) => {
  useEffect(() => {
    try {
      eval(code);
    } catch (error) {
      console.log(error);
    }
  }, [code]);
  return null;
};

export default Script;
